<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-list lines="none">
          <ion-item lines="none" class="input-small">
            <ion-input [(ngModel)]="take.takeName" (keyup.enter)="saveTakeName()" placeholder="Take Name"></ion-input>

            <ion-button aria-label="Save Take Name" (click)="saveTakeName()" class="grey"> Save </ion-button>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
